import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Dish, UpdateDishDto } from 'types';

export const updateDish = ({
  data,
  dishId,
}: {
  data: UpdateDishDto;
  dishId: number;
}): Promise<Dish> => {
  return axios.put(`/api/dishes/${dishId}`, data);
};

type UseUpdateDishOptions = {
  config?: MutationConfig<typeof updateDish>;
};

export const useUpdateDish = ({ config }: UseUpdateDishOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousDishs) {
        queryClient.setQueryData(['dishes'], context.previousDishs);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['dishes']);
      queryClient.invalidateQueries(['analyzerDish']);
      queryClient.invalidateQueries(['weatherAlerts']);
      queryClient.invalidateQueries(['locations']);
      queryClient.invalidateQueries(['systemOverview']);
    },
    ...config,
    mutationFn: updateDish,
  });
};
